import { useContext } from 'react';
import { UserContext } from 'contexts/UserContext';

export function selectedCompanyId(selectedCompany) {
  const companyId = Number(selectedCompany?.id);
  return Number.isSafeInteger(companyId) && companyId > 0 ? companyId : null;
}

export default function useCurrentCompanyId() {
  const { selectedCompany } = useContext(UserContext);
  return selectedCompanyId(selectedCompany);
}
